export const homeObjOne = {
    lightBg: false,
    primary: true, 
    imgStart: '', 
    lightTopLine: true,
    lightTextDesc: true,
    buttonLabel: 'Get Started',
    description: 'We have help business appear to larger demographic, by building their websites which will lead to an increase in visibility and revenue.',
    headline: 'Online visibility to customers leads to revenue increase', 
    lightText: true,
    topLine: 'Marketing Agency',
    alt: 'image',
    img: require('../../images/image1.svg').default,
    start: ''
}

export const homeObjTwo = {
    lightBg: true,
    primary: false,
    imgStart: 'start', 
    lightTopLine: false,
    lightTextDesc: false,
    buttonLabel: 'Get Started',
    description: 'We have help business appear to larger demographic, by building their websites which will lead to an increase in visibility and revenue.',
    headline: 'Online visibility to customers leads to revenue increase', 
    lightText: false,
    topLine: 'Marketing Agency',
    alt: 'image',
    img: require('../../images/profile.jpg').default,
    start: 'true'
}

export const homeObjThree = {
    lightBg: false,
    primary: true,  
    imgStart: '', 
    lightTopLine: true,
    lightTextDesc: true,
    buttonLabel: 'Get Started',
    description: 'We have help business appear to larger demographic, by building their websites which will lead to an increase in visibility and revenue.',
    headline: 'Online visibility to customers leads to revenue increase', 
    lightText: true,
    topLine: 'Marketing Agency',
    alt: 'image',
    img: require('../../images/image2.svg').default,
    start: ''
}

export const homeObjFour = {
    lightBg: false,
    primary: true, 
    imgStart: 'start', 
    lightTopLine: true,
    lightTextDesc: true,
    buttonLabel: 'Get Started',
    description: 'We have help business appear to larger demographic, by building their websites which will lead to an increase in visibility and revenue.',
    headline: 'Online visibility to customers leads to revenue increase', 
    lightText: true,
    topLine: 'Marketing Agency',
    alt: 'image',
    img: require('../../images/image3.svg').default,
    start: 'true'
}